import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStatus, SUCCESS, ERROR } from '@rootstrap/redux-tools';

import useToast from 'hooks/useToast';

import { deleteEvent } from 'state/actions/eventActions';

export default callback => {
  const dispatch = useDispatch();
  const { status } = useStatus(deleteEvent);
  const { showToast, showErrorToast } = useToast();

  useEffect(() => {
    if (status === SUCCESS) {
      showToast('Event successfully deleted!');
      dispatch(deleteEvent.reset());
      callback();
    }
    if (status === ERROR) {
      showErrorToast('There was an error trying to delete your event.');
      dispatch(deleteEvent.reset());
    }
  });

  return useCallback((celebrityId, eventId) => dispatch(deleteEvent(celebrityId, eventId)), [
    dispatch
  ]);
};
